import { hide, show, ajaxPost } from './lib/jsfunc.js'
import { on, ready, query } from './lib/dom.js'
import postToUrl from './lib/postToUrl.js'

ready(function() {
  var pagehome = document.getElementById('page-home')
  var pageknowledgesub = document.getElementById('page-knowledge-sub')
  var pagecorporation = document.getElementById('page-corporation')
  var NavMenu = query('.NavMenu')

  if (pagehome || pageknowledgesub || pagecorporation || NavMenu) {
    hide('.CIRCLES')
  }

  if (query('.AddToCart')) {
    var inpAnzahl = query('.AddToCart form input.anzahl')
    on('click', '.AddToCart tr.submit .Button', function(event) {
      event.preventDefault()

      var tr = event.target.closest('tr')
      if ( !tr) return false

      var url = tr.getAttribute('data-url')
      var anzahl = query('.AddToCart form input.anzahl')
      if (anzahl.value > 0){

        if (window.gtag && window.gtag.add_to_cart) {
          window.gtag.add_to_cart([ document.title ])
        }

        ajaxPost(url, {anzahl:anzahl.value}, function (request) {
          var data = JSON.parse(request.responseText)
          anzahl.value = data['anzahl']
          if ( !query('.NavMenu') && data['cartbox'] && data['cartpopup']) {
            query('.CartBox').outerHTML = data['cartbox']
            query('.infolayer-cart-popup').outerHTML = data['cartpopup']
            show('.infolayer-cart-popup')
          }
        })
      }
    })
  }

  if(query('.InfoLayer')){
    on('click', '.infolayer-cart-popup a.loeschen .icons-trash', function(event) {
      event.preventDefault();
      var table = event.target.closest( 'table');

      var url = event.target.getAttribute('href');
      if(!url){
        var url = event.target.closest( 'a').getAttribute('href');
      }
      ajaxPost(url, {}, function (request){
        var data = JSON.parse(request.responseText);

        if(!query('.NavMenu') && data['cartbox'] && data['cartpopup']){
          query('.CartBox').outerHTML = data['cartbox'];
          query('.infolayer-cart-popup').outerHTML = data['cartpopup'];
          show('.infolayer-cart-popup');
        }
      });
    })
  }
  
  if(query('.CartInputTable')){
    on('click', '.CartInputTable a.loeschen', function(event){
      event.preventDefault();
      postToUrl(event.target.getAttribute('href'), {});
    })
  }

  if(query('.shop')){
    
    on('click', '.shop.cart .Button.address', function(event) {
      event.preventDefault();
      if(!event.target.matches('.disabled')){
        query('.shop.cart form').submit();
      }
    })

    on('click', '.shop.address a.continue', function(event) {
      event.preventDefault();
      query('.shop.address > form').submit();
    })

    on('change', '.shop.checkout input.checkAGBs', function(event) {
      event.preventDefault();
      var span = query('.shop.checkout span.error');
      var button = query('.shop.checkout .Button.continue');

      if(event.target.checked){
        hide(span);
        button.classList.remove('disabled');
      }else{
        show(span);
        button.classList.add('disabled');
      }
    })
    on('click', '.shop.delivery a.continue', function(event){
      event.preventDefault();
      var deliveryAccNr = query('input.deliveryAccNr');
      if(deliveryAccNr.style.visibility == 'hidden'){
        deliveryAccNr.value = '';
      }
      if(!event.target.matches('.disabled')){
        query('.shop.delivery form').submit();
      }
    })

    on('click', '.shop.checkout .Button.continue', function(event) {
      event.preventDefault();
      if(!event.target.matches('.disabled'))
        query('.shop.checkout form').submit();
    })
  
    on('click', '.shop.payment .Button.cancel', function(event){
      event.preventDefault();
      if(!event.target.matches('.disabled')){
        postToUrl(event.target.getAttribute('href'), {});
      }
    })
    
    var form = query('.shop.payment form');
    if (form){
      on('click', '.shop.payment .Button', function(event){
        if(event.target.matches('.disabled')){
          event.preventDefault();
          event.stopPropagation();
          return false;
        }else{
          event.target.classList.add('disabled');
          form.submit();
          event.target.classList.remove('disabled');
          event.preventDefault();
        }
      })
    }else{
      on('click', '.shop.payment .Button', function(event){
        event.preventDefault();
        if(!event.target.matches('.disabled')){
          postToUrl(event.target.getAttribute('href'), {});
        }
      })
    }
  }
  
  if(query('.application-contact')){
    on('click', '.application-contact .Buttons .Button.continue', function(event) {
      event.preventDefault();
      query('.application-contact > form').submit();
    })
  }
  
  if(query('.application-uploads')){
    on('click', '.application-uploads .Buttons .Button.submit', function(event) {
      event.preventDefault();
      if(!event.target.matches('.disabled')){
        query('.application-uploads form.sendapplication').submit();
      }
    })
  }
  
  if(query('.Tree')){
    on('click', '.Tree .handle', function(event) {
      var handle = event.target;
      var parent = handle.parentNode;
      if(!parent.hasChildNodes()){
        return;
      }
      
      var childs = parent.children;
      for(var c=0; c<childs.length;++c){
        var child = childs[c];
        if(!child.matches('.children')){
          continue;
        }
        if(getComputedStyle(child).display === 'none'){
          child.style.visibility = 'visible';
          child.style.display = 'block';
          handle.classList.remove('icon-plus');
          handle.classList.add('icon-minus');
        }else{
          child.style.visibility = 'hidden';
          child.style.display = 'none';
          handle.classList.add('icon-plus');
          handle.classList.remove('icon-minus');
        }
      }
    })
  }
})
